import React, {memo, useEffect, useMemo, useState} from "react";
import cn from "classnames";
import * as Input from "@UI/InputNew";
import { useInputNew } from "@UI/InputNew/useInputNew";
import { InputNew, InputWrapper } from "@UI/InputNew";
import Button, { ButtonAdd, ButtonDel, ButtonEdit } from "@UI/Button";
import { getInArr } from "@/helpers/getInArr";
import { useGetNameRole } from "@/helpers/useGetNameRole";
import { billingConversion } from "@/helpers/billingConversion";
import { useScreenWidth } from "@/hooks/useScreenWidth";
import { GetIco } from "@/utils/icons";
import s from "./BodyEdit.module.css";
import { Config } from "@/config";
import rolesEnum from "@/constant/rolesEnum";
import {classApi, directionOrdersApi, usersAPI, departments as departmentsApi} from "@/api";
import Row from "@UI/Row";
import {useConfirm} from "@/hooks/useConfirm";
import {useAddAlert} from "@/hooks/useAddAlert";
import Modal from "@common/Modal";
import ModalAddDepartments from "./ModalAddDepartments";
import ModalRemoveClass from "./ModalRemoveClass";
import {IcoRemove} from "@pages/Admin/constsIcon";
import {InputNumber} from "antd";
import { checkSettingsStore } from '../../../../services/SettingsStoreUpdateService';
import { useSelector } from "react-redux";
import CustomFields from './CustomFields';
import Moment from 'react-moment';
import moment from "moment";
import { getCorrectFilePath } from "@/helpers/new/getCorrectFilePath";
import { WorkHoursSchedule } from "@common/WorkHours";
import { LiveDigitalLinkHint } from "@common/LiveDigitalLinkHint";
moment.locale('ru')

export const BodyEdit = (props) => {
  return props.isEmployee
    ? <Body {...props} />
    : <BodyChildren {...props} />
}

const Body = (props) => {
  const [departments, setDepartments] = useState([]);
  const addAlert = useAddAlert()
  useEffect(()=>{
    loadDepartments();
  }, [])
  const loadDepartments = () => {
    if(props?.user?.id){
      departmentsApi.userScriptorAdeptoDepartments(props?.user?.id)
      .then((res)=>{
        setDepartments(res.data)
      });
    }
  }
  const deleteEmployee = (idUser, idDepartment) => {
    departmentsApi.deleteEmployee({
      userId: idUser,
      unitId: idDepartment
    })
    .then((res)=>{
      if(res.data===true){
        loadDepartments();
        addAlert({text: 'Сотрудник удален из отдела'})
      }
    })
  }
  const [modalActive, setModalActive] = useState(false);

  const seminarianAccess =
    getInArr("seminarian", props.user.rolesName) ||
    getInArr("senior-seminarian", props.user.rolesName);

  return (
    <div className={cn(s.wrapper, s.managing)}>
      <div className={s.left}>
        <EditInput
          name="email"
          label="Электронная почта"
          required={false}
          {...props}
        />
        <EditInputPhone {...props} />
        <EditInputSex {...props} />
        <EditInputDate {...props} />
        {seminarianAccess && (
          <EditInput name="education" label="Образование" {...props} />
        )}
        {seminarianAccess && (
          <EditInput name="experience" label="Опыт работы" {...props} />
        )}
        {seminarianAccess && (
          <div className={s.fieldWithHint}>
            <EditInput
              name="url_conference"
              type="url"
              label="Постоянная ссылка на ВКС"
              {...props}
            />
            <LiveDigitalLinkHint value={props.user?.url_conference} />
          </div>
        )}
        {seminarianAccess && props.isTelebosIntegrationEnabled && (
          <EditInput
            name="telebos_room_id"
            label="ID комнаты Telebos"
            {...props}
          />
        )}
        <EditInput name="link_to_vk" label="Ссылка вконтакте" {...props} />
        <EditInput name="city" label="Город" {...props} />
        <EditInput name="address" label="Адрес регистрации" {...props} />
        <EditInputAbout {...props} />
        <EditWorkHours {...props} />
      </div>
      <div className={s.right}>
        <Roles {...props} />
        {Config.RATE_PER_TEACHER_ON_CARD && <Rate {...props} />}
        {Config.RATE_PER_TEACHER_ON_CARD && <RateGroup {...props} />}
        <Contracts {...props} />
      </div>
      <div>
      <span style={{marginBottom: '5px', fontWeight: '500', fontSize: '13px', color: 'var(--color-gray)'}}>Отделы:</span>
      <ul style={{maxWidth:'250px'}} className={s.list}>
        {departments.map((el)=>{
          return(
            <li key={el.id}>
              <span className={cn(s.booble)}>
                {el.name}
              </span>
              <ButtonDel className={s.itemButton} onClick={() => deleteEmployee(props?.user?.id, el.id)} />
            </li>
          )
        })}
      </ul>
      <Button
        style={{marginTop:'10px', width: '100px'}}
        className={s.addText}
        onClick={() => setModalActive(true)}
      >
        <GetIco style={{position:'relative', top: '-1px'}} icon="plus" /> Отдел
      </Button>
      </div>
      
      {/* <Notes {...props} /> */}
      <Modal active={modalActive} setActive={() => setModalActive(false)}>
          <IcoRemove className={s.icoRemove} onClick={() => setModalActive(false)}/>
          <ModalAddDepartments
              departments={departments}
              setActive={setModalActive}
              userId={props?.user?.id}
              loadDepartments={loadDepartments}
          />
      </Modal>
    </div>
  );
};

const BodyChildren = (props) => {
  const addAlert = useAddAlert()
  const isSeminarian =
      getInArr("seminarian", props.user.rolesName) ||
      getInArr("senior-seminarian", props.user.rolesName);

  checkSettingsStore()
  .catch((error) => {
      addAlert({
          title: `УПС! Возникла ошибка... Настройки платформы не загружены...`,
          text: error?.message,
          type: 'error'
      });
  });
  const isShowPhoneChildStore = useSelector(store => store.settings.isShowPhoneChild);
  const isShowEmailChildStore = useSelector(store => store.settings.isShowEmailChild);
  const isShowGenderChildStore = useSelector(store => store.settings.isShowGenderChild);
  const isShowDateOfBirthChildStore = useSelector(store => store.settings.isShowDateOfBirthChild);
  const isShowClassChildStore = useSelector(store => store.settings.isShowClassChild);
  const isShowLinkToSocialMediaNetChildStore = useSelector(store => store.settings.isShowLinkToSocialMediaNetChild);
  const isShowCityChildStore = useSelector(store => store.settings.isShowCityChild);
  const isShowIdChildStore = useSelector(store => store.settings.isShowIdChild);
  const isShowAboutMeChildStore = useSelector(store => store.settings.isShowAboutMeChild);
  const isShowAboutChildStore = useSelector(store => store.settings.isShowAboutChild);
  const isShowTimeZoneChildStore = useSelector(store => store.settings.isShowTimeZoneChild);
  const isShowParentNameChildStore = useSelector(store => store.settings.isShowParentNameChild);
  const isShowParentPhoneChildStore = useSelector(store => store.settings.isShowParentPhoneChild);
  const isShowClassesChildStore = useSelector(store => store.settings.isShowClassesChild);
  const isShowCoursesChildStore = useSelector(store => store.settings.isShowCoursesChild);
  const isShowAgreementsChildStore = useSelector(store => store.settings.isShowAgreementsChild);
  const isShowCustomFieldsChildStore = useSelector(store => store.settings.isShowCustomFieldsChild);
  const customFieldsChildStore = useSelector(store => store.settings.customFieldsChild);

  return (
    <>
      <div className={cn(s.wrapper, s.children)}>
        {
          (isShowEmailChildStore == 1)?
          <EditInput name="email"
                   label="Электронная почта"
                   required={true}
                   disabled={isSeminarian}
                   {...props}
          /> :
          ''
        }
        {
          (isShowPhoneChildStore == 1)?
          <EditInputPhone disabled={isSeminarian} {...props} /> :
          ''
        }
        
        {
          (isShowGenderChildStore == 1)?
          (<EditInputSex disabled={isSeminarian} {...props} />) :
          ''
        }
        {
          (isShowDateOfBirthChildStore == 1)?
          (<EditInputDate disabled={isSeminarian} {...props} />) :
          ''
        }
        {
          (isShowClassChildStore == 1)?
          (<EditInput name="learning_class"
                    label="Класс"
                    className={s.class}
                    {...props}
          />) : ''
        }
        {
          (isShowLinkToSocialMediaNetChildStore == 1)?
          (<EditInput name="link_to_vk" label="Ссылка на соц. сеть " {...props} />) :
          ''
        }
        {
          (isShowCityChildStore == 1)?
          (<EditInput name="city" label="Город" {...props} />) :
          ''
        }
        {/* <EditInput name='spent' label='Потрачено' {...props} /> */}
        {/* <EditInput name='ltv' label='LTV' {...props} /> */}
        <EditInput name="promo_code"
                   label="Реф.Промокод"
                   disabled={true}
                   {...props}
        />
        {
          (isShowIdChildStore == 1)?
          (<EditInputCustomId {...props} />):
          ''
        }
      </div>

      <div className={cn(s.wrapper, s.children)}>
        {
          (isShowAboutMeChildStore == 1)?
          (<EditInputAbout {...props} />) :
          ''
        }
        {/*{props.user.role === 'seminarian' &&*/}
        {/*    <span>Рабочее время сотрудника</span>*/}
        {/*}*/}
        {
          (isShowAboutChildStore == 1)?
          (<EditInputAboutStudent {...props} />) :
          ''
        }
        {
          (isShowAgreementsChildStore == 1)?
          (<Contracts {...props} />) :
          ''
        }
      </div>

      { ((isShowParentNameChildStore == 1) || (isShowParentPhoneChildStore == 1)) &&
        <>
          <p className={s.parentName}>Родитель</p>
          <div className={cn(s.wrapper, s.children)}>
          {
              (isShowParentNameChildStore == 1)?
              (<EditInput
                name="parent_name"
                label="ФИО"
                className={s.fio}
                {...props}
              />) :
              ''
            }
            {
              (isShowParentPhoneChildStore == 1)?
              (<EditInputPhone parent={true} {...props} />) :
              ''
            }
            {
              (isShowTimeZoneChildStore == 1)?
              (<EditInput
                name="timezone"
                label="Часовой пояс"
                className={s.timezone}
                {...props}
                />) :
              ''
            }
            <CommunicationMethod {...props} />
          </div>
        </>
      }

      {
        (isShowClassesChildStore == 1)?
        (<Classes {...props} />) :
        ''
      }
      {
        (isShowCoursesChildStore == 1)?
        (<Directions {...props} />) :
        ''
      }

      <PersonalTariff {...props} />
      {
        (false && isShowCustomFieldsChildStore == 1)?
        (<div className={s.dop_fields}>
          <div className={s.dop_fields_title}>Дополнительные поля</div>
          { customFieldsChildStore.map((el, i) =>
            <CustomFields key={i} { ...el } props={props} />)
          }
        </div>) :
        ''
      }
    </>
  );
};

const EditInput = ({ name, label, required, className, ...props }) => {
  
  const [bind] = useInputNew({
    name: name,
    value: props.user[name],
    onChange: (e) => props.edit(name, e),
    onError: required ? props.validate.setErrorsList : () => {},
    validate: required ? props.validate.showErrors : false,
    placeholder: label,
    title: label,
    disabled: !props.settingCard.editMode,
  });
  return (
    <Input.InputNew className={cn({ [className]: className })} {...bind} />
  );
};

const EditInputCustomId = (props) => {
  const [bind] = useInputNew({
    value: props.user.custom_id,
    onChange: (e) => props.edit('custom_id', e),
    title: "ID",
    placeholder: props.settingCard.editMode ? "Введите ID" : "Не указано",
    disabled: !props.settingCard.editMode,
  });
  return <Input.InputNew {...bind} />;
}

const EditInputSex = (props) => {
  const [bind] = useInputNew({
    name: "sex",
    value: props.user.sex,
    onChange: (e) => props.edit("sex", e),
    placeholder: props.settingCard.editMode ? "Выбрать" : "Не указано",
    title: "Пол",
    options: [
      { label: "М", value: "male" },
      { label: "Ж", value: "female" },
    ],
    disabled: !props.settingCard.editMode,
  });
  return <Input.InputSelect className={s.sex} {...bind} />;
};

const EditInputDate = (props) => {
  const [bind] = useInputNew({
    name: "birth_date",
    value: props.user.birth_date,
    onChange: (e) => props.edit("birth_date", e),
    title: "Дата рождения",
    disabled: !props.settingCard.editMode,
  });
  return <Input.InputDate {...bind} />;
};

const EditInputPhone = (props) => {
  const [bind] = useInputNew({
    name: props.parent ? "parent_phone" : "phone",
    value: props.parent ? props.user.parent_phone : props.user.phone,
    onChange: (e) => props.edit(props.parent ? "parent_phone" : "phone", e),
    title: "Номер телефона",
    disabled: !props.settingCard.editMode,
  });
  return <Input.InputTel {...bind} />;
};

const EditInputAbout = (props) => {
  const [bind] = useInputNew({
    name: "about",
    value: props.user.about,
    onChange: (e) => props.edit("about", e),
    title: "О себе",
    disabled: true,
  });
  return <Input.InputTextarea className={s.about} {...bind} />;
};

const EditInputAboutStudent = (props) => {
  const [bind] = useInputNew({
    name: "about_student",
    value: props.user.about_student,
    onChange: (e) => props.edit("about_student", e),
    title: "Об ученике (Не видно учащемуся)",
    disabled: !props.settingCard.editMode,
  });
  return <Input.InputTextarea className={s.about} {...bind} />;
};


const EditWorkHours = (props) => {
  const editable =
    props.settingCard.editMode && props.userRole !== "senior-seminarian";

  return (
    <WorkHoursSchedule
      workHours={props.user.workHours}
      editable={editable}
      onEdit={() => props.setModal("AddWorkHours")}
    />
  );
}

const Roles = (props) => {
  return (
      <InputWrapper title="Должности">
      <ul className={cn(s.list, Config.RATE_PER_TEACHER_ON_CARD && s.list__rate)}>
        {props?.user?.roles?.map((role, i) => {
          if (
            role.item_name === "seminarian" &&
            props?.user?.seminarianDirection?.length
          ) {
            return props?.user?.seminarianDirection.map((direction) => {
              return (
                <li key={direction.id}>
                  <span className={cn(s.booble)}>
                    <span className={s.subBooble}>Педагог</span>{" "}
                    {direction.name}
                  </span>
                  {!Config.RATE_PER_TEACHER_ON_CARD &&
                    props.userRole !== "senior-seminarian" &&
                    props.settingCard.editMode && (
                      <ButtonDel
                        className={s.itemButton}
                        onClick={() =>
                          props.setModal(
                            "RemoveSeminarianDirection",
                            direction.linkId
                          )
                        }
                      />
                    )}
                </li>
              );
            });
          }
          return (
            <li key={i}>
              <span className={cn(s.booble)}>
                <UserRole {...{ role }} />
              </span>
              {!Config.RATE_PER_TEACHER_ON_CARD && props.userRole !== "senior-seminarian" &&
                props.settingCard.editMode && (
                  <ButtonDel
                    className={s.itemButton}
                    onClick={() => props.setModal("RemovePost", i)}
                  />
                )}
            </li>
          );
        })}
      </ul>
      {props.userRole !== "senior-seminarian" && props.settingCard.editMode && (
        <>
          <div className={cn("new_space", s.addTextBtns)}>
            <Button
              className={s.addText}
              action={() =>
                props.setModal("AddPost", { rolesName: props.user.rolesName })
              }
            >
              <GetIco icon="plus" /> Должность
            </Button>
            {getInArr("seminarian", props.user.rolesName) && (
              <Button
                className={s.addText}
                action={() => props.setModal("AddSeminarianDirection")}
              >
                <GetIco icon="plus" />
                Направление
              </Button>
            )}
          </div>
        </>
      )}
    </InputWrapper>
  );
};

const Rate = (props) => {
  let rateChangeTimeout = null;

  const onChange = (e, linkId) => {
    const rate = Number(e.target.value?.replace(/[^0-9]/g, ""))

    const newSeminarianDirection = props?.user?.seminarianDirection.map(direction => {
      if (direction.linkId === linkId) {
        direction.rate = rate
      }

      return direction
    })

    props.edit('seminarianDirection', newSeminarianDirection)

    clearTimeout(rateChangeTimeout)

    rateChangeTimeout = setTimeout(() => {
      usersAPI.changeDirection({
        id: linkId,
        data: { rate }
      })
    }, 250)
  }

  return (
    <InputWrapper title="Ставка за занятие (индивид.)" className={s.rateWrapper}>
      <ul className={s.list}>
        {props?.user?.roles?.map((role, i) => {
          if (role.item_name === "seminarian" && props?.user?.seminarianDirection?.length) {
            return props?.user?.seminarianDirection.map((direction) => {
              return (
                <li key={direction.id + '_' + i}>
                  <InputNew disabled={!props.settingCard.editMode}
                            style={{maxHeight: 56}}
                            value={direction.rate}
                            onChange={e => onChange(e, direction.linkId)}
                  />

                  {props.userRole !== rolesEnum.seniorSeminarian && props.settingCard.editMode &&
                    <ButtonDel className={s.itemButton}
                               onClick={() => props.setModal("RemoveSeminarianDirection", direction.linkId)}
                    />
                  }
                </li>
              );
            });
          }

          return (
            <li key={i} className={cn(s.booble, s.boobleTransparent)}>
              {props.userRole !== rolesEnum.seniorSeminarian && props.settingCard.editMode &&
                <ButtonDel className={s.itemButton} onClick={() => props.setModal("RemovePost", i)} />
              }
            </li>
          );
        })}
      </ul>
    </InputWrapper>
  );
};

const RateGroup = (props) => {
  let rateChangeTimeout = null;

  const onChange = (e, linkId) => {
    const rate_group = Number(e.target.value?.replace(/[^0-9]/g, ""))

    const newSeminarianDirection = props?.user?.seminarianDirection.map(direction => {
      if (direction.linkId === linkId) {
        direction.rate_group = rate_group
      }

      return direction
    })

    props.edit('seminarianDirection', newSeminarianDirection)

    clearTimeout(rateChangeTimeout)

    rateChangeTimeout = setTimeout(() => {
      usersAPI.changeDirection({
        id: linkId,
        data: { rate_group }
      })
    }, 250)
  }

  return (
      <InputWrapper title="Ставка за час (групп.)" className={s.rateWrapper}>
        <ul className={s.list}>
          {props?.user?.roles?.map((role, i) => {
            if (role.item_name === "seminarian" && props?.user?.seminarianDirection?.length) {
              return props?.user?.seminarianDirection.map((direction) => {
                return (
                    <li key={direction.id + '_' + i}>
                      <InputNew disabled={!props.settingCard.editMode}
                                style={{maxHeight: 56}}
                                value={direction.rate_group}
                                onChange={e => onChange(e, direction.linkId)}
                      />

                      {props.userRole !== rolesEnum.seniorSeminarian && props.settingCard.editMode &&
                          <ButtonDel className={s.itemButton}
                                     onClick={() => props.setModal("RemoveSeminarianDirection", direction.linkId)}
                          />
                      }
                    </li>
                );
              });
            }

            return (
                <li key={i} className={cn(s.booble, s.boobleTransparent)}>
                  {props.userRole !== rolesEnum.seniorSeminarian && props.settingCard.editMode &&
                      <ButtonDel className={s.itemButton} onClick={() => props.setModal("RemovePost", i)} />
                  }
                </li>
            );
          })}
        </ul>
      </InputWrapper>
  );
};

const UserRole = ({ role }) => useGetNameRole(role);

const Contracts = (props) => {
  return (
    <InputWrapper title="Договоры">
      <ul className={s.list}>
        {props.user?.contracts?.map((item) => (
          <li key={item.id}>
            <span className={cn(s.booble)}>
              {" "}
              <a
                href={getCorrectFilePath(item.file_path)}
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                {item.name}{" "}
              </a>
            </span>
            {props.userRole !== "senior-seminarian" && (
                <ButtonDel
                  className={s.itemButton}
                  onClick={() => props.setModal("RemoveContract", item.id)}
                />
              )}
          </li>
        ))}
      </ul>
      {props.userRole !== "senior-seminarian" && (
        <ButtonAdd
          className={s.itemAdd}
          onClick={() => props.setModal("AddContract")}
        />
      )}
    </InputWrapper>
  );
};

// const Notes = props => {
//   return <InputWrapper title='Заметки'>
//     <ul className={s.list}>
//       {props.user?.notes?.map((el, index) =>
//         <li key={index}>
//           <InputNotes {...props} />
//           {props.userRole !== 'senior-seminarian' && props.settingCard.editMode && <ButtonDel className={s.itemButton} onClick={() => props.removeNote(index)} />}
//         </li>
//       )}
//     </ul>
//     {props.settingCard.editMode && <ButtonAdd className={s.itemAdd} onClick={() => props.setModal("AddNotes")} />}
//   </InputWrapper>
// }

// const InputNotes = props => {
//   const [bind] = useInputNew({
//     name: 'phone',
//     // value: props.user.phone,
//     // onChange: e => props.edit('phone', e),
//     // title: 'Номер телефона',
//     // disabled: props.settingCard.editMode ? false : true,
//   })
//   return <Input.InputNew {...bind} />
// }

const CommunicationMethod = (props) => {
  const selectTL = () =>
    props.edit(
      "parent_telegram",
      props.user.parent_telegram === "1" ? "0" : "1"
    );
  const selectWt = () =>
    props.edit(
      "parent_whatsapp",
      props.user.parent_whatsapp === "1" ? "0" : "1"
    );

  return (
    <InputWrapper title="Способ связи">
      <div className={s.communicationWrapper}>
        <span
          onClick={() => props.settingCard.editMode && selectTL()}
          className={cn(
            "social social--tl",
            { "social--disable": props.user.parent_telegram !== "1" },
            { [s.disableSocial]: !props.settingCard.editMode }
          )}
        ></span>
        <span
          onClick={() => props.settingCard.editMode && selectWt()}
          className={cn(
            "social social--wt",
            { "social--disable": props.user.parent_whatsapp !== "1" },
            { [s.disableSocial]: !props.settingCard.editMode }
          )}
        ></span>
      </div>
    </InputWrapper>
  );
};

const Classes = (props) => {
  const confirm = useConfirm()
  const addAlert = useAddAlert()
  const [classes, setClasses] = useState([])

  const [modalRemoveClass, setModalRemoveClass] = useState({
    active: false,
    data: {}
  });

  const closeModalRemoveClass = () => {
    setModalRemoveClass({active: false, data: {}})
   }
  const openModalRemoveClass = (data) => {
    setModalRemoveClass({active: true, data})
  }

  useEffect(() => {
    fetchClasses()
  }, []);

  const fetchClasses = () => {
    classApi
      .showByUser(props.user.id)
      .then(({ data }) => {
        setClasses(data?.data ?? [])
      })
  }

  const handleAttachClass = () => {
    props.setModal("AddClass", {
      selected: props.user.childrenDirection
        ?.filter(({ class_id }) => classes.find(c => c.id === class_id))
        ?.map(({ class_id }) => class_id),
      onSuccess: () => {
        props.modalOptions?.getDirection()
        fetchClasses()
      },
      onError: ({ data }) => addAlert({
        type: 'error',
        title: 'Не удалось добавить класс',
        text: Object.entries(data.data)[0][1] || ''
      })
    })
  }

  const handleDetachClass = (elClass) => {
    openModalRemoveClass({
      user_id: props.user.id,
      elClass: elClass
    })
    // confirm({
    //   text: `Вы действительно хотите удалить ученика из класса "${elClass.title}"?`,
    //   onConfirm: () => {
    //     classApi.detachChildren(elClass.id, {
    //       user_id: props.user.id
    //     }).then(() => {
    //       setClasses(classes.filter(c => c.id !== elClass.id))
    //       fetchClasses()
    //     })
    //   }
    // })
  }

  const handleTransferClass = (elClass) => {
    props.setModal("AddClass", {
      mode: 'transferClass',
      fromClassId: elClass.id,
      selected: classes.map(({ id }) => id),
      onSuccess: () => {
        props.modalOptions?.getDirection()
        fetchClasses()
      },
      onError: ({ data }) => addAlert({
        type: 'error',
        title: 'Не удалось перевести класс',
        text: data?.error?.[0] || data?.message || Object.entries(data?.data ?? {})[0]?.[1] || ''
      })
    })
  }

  const handleAttachGroup = (elClass) => {
    props.setModal("AddGroupToClass", {
      classId: elClass.id,
      selected: props.user.childrenDirection
        ?.filter(({ class_id }) => class_id === elClass.id)
        ?.map(({ group_id }) => group_id),
      onSuccess: () => {
        props.modalOptions?.getDirection()
        fetchClasses()
      },
      onError: ({ data }) => addAlert({
        type: 'error',
        title: 'Не удалось добавить группу',
        text: Object.entries(data.data)[0][1] || ''
      })
    })
  }

  const handleDetachGroup = (group, elClass) => {
    confirm({
      text: `Вы действительно хотите удалить ученика из группы "${group.name}"?`,
      onConfirm: () => {
        classApi.detachUserClassGroup(elClass.id, {
          direction_group_id: group.id,
          user_id: props.user.id,
        }).then(() => {
          setClasses(classes.map(c => {
              c.groups = c.groups?.filter(g => g.id !== group.id)

              return c
            })
          )

          props.modalOptions
            ?.getDirection()
            ?.then(() => fetchClasses())
        })
      }
    })
  }

  const isDisabled = (elClass) => {
    const groupsCount = props.user.childrenDirection
      ?.filter(order => order.class_id === elClass.id)
      // ?.filter(order => getInArr(order.group_id, []))
      ?.length

    return groupsCount >= elClass.groups?.length
  }

  // const RenderClass = ({ elClass, props }) => {
  //
  //   const [editPrice, setEditPrice] = useState(true);
  //
  //   const handleChange = (event) => {
  //     setEditPrice(false);
  //   };
  //
  //   const openEdit = () => {
  //     setEditPrice(true);
  //   }
  //   const [inputValue, setInputValue] = useState(elClass.classUser?.amount ?? elClass.amount);
  //   const ClassPriceInput = ({ elClass, editPrice, setEditPrice, inputValue }) => {
  //     const handleChange = (event) => {
  //       setInputValue(event.target.value);
  //     };
  //
  //     const savePrice = () => {
  //       setEditPrice(false);
  //       // Optionally, add code to save the new price
  //     };
  //
  //     const openEdit = () => {
  //       setEditPrice(true);
  //     };
  //
  //     return (
  //         <div role="button" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
  //           <InputNumber value={inputValue} />
  //           {editPrice && <div onClick={handleChange} style={{transform: 'scale(2)', marginLeft: '1rem'}}>
  //             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
  //                  className="bi bi-check-circle-fill" viewBox="0 0 16 16">
  //               <path
  //                   d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
  //             </svg>
  //           </div>}
  //           {!editPrice && <div onClick={openEdit} style={{transform: 'scale(2)', marginLeft: '1rem'}}>
  //             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
  //                  className="bi bi-pencil-fill" viewBox="0 0 16 16">
  //               <path
  //                   d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
  //             </svg>
  //           </div>}
  //         </div>
  //     );
  //   };
  //
  //   return (
  //       <div key={elClass.id} className={s.classWrapper} style={{width: '100%'}}>
  //         <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
  //           <div className={s.classTitle}>
  //             Класс: {elClass.title}
  //           </div>
  //           {(!props.settingCard.editMode || !editPrice) &&
  //               <div>{elClass.classUser?.amount ?? elClass.amount} руб/месяц</div>}
  //           {props.settingCard.editMode && editPrice &&
  //               <div><ClassPriceInput elClass={elClass}></ClassPriceInput> руб/месяц</div>
  //           }
  //         </div>
  //
  //         {
  //           elClass.groups
  //               ?.filter(group => props.user.childrenDirection?.find(order => order.group_id === group.id))
  //               ?.map((group, i) => renderGroup(group, i, elClass))
  //         }
  //
  //         {props.settingCard.editMode &&
  //             <Row>
  //               <Button styles={'yellow'}
  //                       disable={isDisabled(elClass)}
  //                       title={isDisabled(elClass) ? 'Все группы для этого класса уже назначены' : ''}
  //                       action={() => handleAttachGroup(elClass)}
  //               >
  //                 Добавить группу
  //               </Button>
  //
  //               <Button styles={'red'} action={() => handleDetachClass(elClass)}>
  //                 Удалить класс
  //               </Button>
  //             </Row>
  //         }
  //       </div>
  //   )
  // }

  const ClassPriceInput = ({ elClass, editPrice, setEditPrice, inputValue, setInputValue, user, valueDiscountActual }) => {
    const handleChange = (event) => {
      setInputValue(event);
    };

    const savePrice = () => {
      let params = {
        class_id: elClass.id,
        amount: Number(inputValue) - Number(valueDiscountActual ?? 0),  // Ensure calculation is done with numbers
        user_id: user.id
      };
      classApi.changePriceForChild(params)
      setEditPrice(false);
    };

    const openEdit = () => {
      setEditPrice(true);
    };

    return (
        <div role="button" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {editPrice ? (
              <>
                <InputNumber value={inputValue} onChange={handleChange} />
                <div role="button" onClick={savePrice} style={{ transform: 'scale(2)', marginLeft: '1rem' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                  </svg>
                </div>
              </>
          ) : (
              <>
                <div style={{marginRight: '1rem'}}>{inputValue}</div>
                <div role="button" onClick={openEdit} style={{ transform: 'scale(1.5)', marginLeft: '1rem' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       className="bi bi-pencil-fill" viewBox="0 0 16 16">
                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                  </svg>
                </div>
              </>
          )}
        </div>
    );
  };

  const ClassDiscountInput = ({ elClass, editDiscount, setEditDiscount, inputValueDiscount, setInputValueDiscount, user, setValueDiscountActual }) => {
    const handleChange = (event) => {
      setInputValueDiscount(event);
    };

    const saveDiscount = () => {
      let params = {
        class_id: elClass.id,
        discount: inputValueDiscount,
        discount_currency: 'rub',
        user_id: user.id
      }
      classApi.changeDiscountForChild(params)
      setValueDiscountActual(inputValueDiscount)
      setEditDiscount(false);
    };

    const openEdit = () => {
      setEditDiscount(true);
    };

    return (
        <div role="button" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {editDiscount ? (
              <>
                <InputNumber value={inputValueDiscount} onChange={handleChange} />
                <div role="button" onClick={saveDiscount} style={{ transform: 'scale(2)', marginLeft: '1rem' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                  </svg>
                </div>
              </>
          ) : (
              <>
                <div style={{marginRight: '1rem'}}>{inputValueDiscount}</div>
                <div role="button" onClick={openEdit} style={{ transform: 'scale(1.5)', marginLeft: '1rem' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       className="bi bi-pencil-fill" viewBox="0 0 16 16">
                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                  </svg>
                </div>
              </>
          )}
        </div>
    );
  };

  const RenderClass = ({ elClass, props }) => {
    const [editPrice, setEditPrice] = useState(true);
    const [editDiscount, setEditDiscount] = useState(true);
    const [inputValue, setInputValue] = useState(
        Number(elClass.classUser?.amount ?? elClass.amount) + Number(elClass.classUser?.discount ?? 0)
    );
    const [inputValueDiscount, setInputValueDiscount] = useState(elClass.classUser?.discount ?? 0);
    const [valueDiscountActual, setValueDiscountActual] = useState(elClass.classUser?.discount ?? 0);

    return (
        <div key={elClass.id} className={s.classWrapper} style={{ width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
            <div style={{display:'flex', flexDirection:'column', gap:'5px'}}>
              <div className={s.classTitle}>
                Класс: {elClass.title}
              </div>
              <div className={s.next_payment}>
                Оплачен до: <Moment date={elClass.classUser.next_payment_date} format="D MMM YYYY" withTitle />
              </div>
            </div>
            {(!props.settingCard.editMode) ? (
                <div>Скидка {elClass.classUser?.discount ?? 0} руб</div>
            ) : (
                <div>
                  <ClassDiscountInput
                      elClass={elClass}
                      editDiscount={editDiscount}
                      setEditDiscount={setEditDiscount}
                      inputValueDiscount={inputValueDiscount}
                      setInputValueDiscount={setInputValueDiscount}
                      setValueDiscountActual={setValueDiscountActual}
                      user={props.user}
                  /> руб
                </div>
            )}

            {(!props.settingCard.editMode) ? (
                <div>{elClass.classUser?.amount ? (Number(elClass.classUser?.amount) + Number((elClass.classUser?.discount ?? 0))) : 0} руб/месяц</div>
            ) : (
                <div>
                  <ClassPriceInput
                      elClass={elClass}
                      editPrice={editPrice}
                      setEditPrice={setEditPrice}
                      inputValue={inputValue}
                      setInputValue={setInputValue}
                      valueDiscountActual={valueDiscountActual}
                      user={props.user}
                  /> руб/месяц
                </div>
            )}
          </div>

          {elClass.groups
              ?.filter(group => props.user.childrenDirection?.find(order => order.group_id === group.id))
              ?.map((group, i) => renderGroup(group, i, elClass))
          }

          {props.settingCard.editMode && (
              <Row>
                <Button styles={'yellow'}
                        disable={isDisabled(elClass)}
                        title={isDisabled(elClass) ? 'Все группы для этого класса уже назначены' : ''}
                        action={() => handleAttachGroup(elClass)}
                >
                  Добавить группу
                </Button>

                <Button styles={'red'} action={() => handleDetachClass(elClass)}>
                  Удалить класс
                </Button>

                {Number(elClass.one_pay) === 1 && (
                  <Button styles={'yellow'} action={() => handleTransferClass(elClass)}>
                    Перевести в др. класс
                  </Button>
                )}
              </Row>
          )}
        </div>
    );
  };

  const renderGroup = (group, key, elClass) => {
    return (
      <div key={key} className={s.classRow}>
        <InputNew title={'Направление'}
                  value={group.direction?.name}
                  disabled
                  readOnly
        />

        <InputNew title={'Тариф'}
                  value={group.direction?.tariffs?.find(tariff => tariff.id === group.tariff_id)?.name}
                  disabled
                  readOnly
        />

        <InputNew title={'Группа'}
                  value={group?.name}
                  disabled
                  readOnly
        />

        <InputNew title={'Преподаватель'}
                  value={group?.seminarian?.name}
                  disabled
                  readOnly
        />

        {props.settingCard.editMode &&
          <ButtonDel onClick={() => handleDetachGroup(group, elClass)}
                     title={'Удалить ученика из группы'}
          />
        }
      </div>
    )
  }

  return (
      <div className={s.classBlock}>
        <p className={s.parentName}>Классы</p>
        {classes?.map((elClass) => (
            <RenderClass
                key={elClass.id}
                elClass={elClass}
                props={props}
            />
        ))}

        {props.settingCard.editMode && (
            <Button onClick={handleAttachClass}>Добавить класс</Button>
        )}

        <Modal active={modalRemoveClass.active} setActive={closeModalRemoveClass}>
            <IcoRemove className={s.icoRemove} onClick={closeModalRemoveClass}/>
            <ModalRemoveClass
               closeModal={closeModalRemoveClass}
               elClass={modalRemoveClass.data.elClass}
               user_id={modalRemoveClass.data.user_id}
               setClasses={setClasses}
               fetchClasses={fetchClasses}
            />
        </Modal>
      </div>
  );
};

const getDirectionSortingValue = (direction) => {
  const sorting = direction?.direction?.sorting

  if (sorting === null || sorting === undefined) {
    return Number.MAX_SAFE_INTEGER
  }

  return Number(sorting)
}

const sortDirectionOrdersByDirectionSorting = (directions = []) =>
  [...directions].sort((direction1, direction2) => {
    const direction1Sorting = getDirectionSortingValue(direction1)
    const direction2Sorting = getDirectionSortingValue(direction2)

    if (direction1Sorting !== direction2Sorting) {
      return direction1Sorting - direction2Sorting
    }

    return Number(direction1?.direction_id ?? direction1?.direction?.id ?? 0) -
      Number(direction2?.direction_id ?? direction2?.direction?.id ?? 0)
  })

const Directions = (props) => {
  const [directionOrders, setDirectionOrders] = useState([])

  useEffect(() => {
    setDirectionOrders(
      sortDirectionOrdersByDirectionSorting(
        props.user.childrenDirection?.filter(({class_id}) => !class_id) ?? [],
      )
    )
  }, [props.user.childrenDirection]);

  const getTariff = (item) =>
    item?.direction?.directionTariffs?.find(
      (tariff) => tariff.id === item.tariff_id
    );

  const handleAddDirection = () => {
    props.setModal("AddDirection", {
      directions: directionOrders?.map(({direction_id}) => direction_id)
    })
  }

  return (
    <div className={cn(s.directionWrapper, "customScroll")}>
      <p className={s.parentName}>Направления</p>

      <div className={cn(s.directionList)}>
        <div className={cn(s.directionRow, s.directionHead)}>
          <span className={s.directionCol}>Направление</span>
          <span className={s.directionCol}>Тариф</span>
          <span className={s.directionCol}>Преподаватель/Группа</span>
        </div>
        {directionOrders?.map((item) => {
          return (
            <div key={item.id} className={s.directionRow}>
              <span className={cn(s.booble, s.directionCol)}>
                {item?.direction?.name}
              </span>
              <span className={cn(s.booble, s.directionCol)}>
                {getTariff(item)?.name}
              </span>

              <span className={cn(s.booble, s.directionCol)}>
                {getTariff(item)?.any_seminarian
                  ? 'Любой учитель'
                  : item?.teacher?.name || 'Не распределён'
                }
              </span>

              <div className={s.directionButtons}>
                {props.settingCard.editMode && (
                  <ButtonDel
                    onClick={() => props.setModal("RemoveDirection", item.id)}
                  />
                )}
              </div>
              <div className={s.directionButtons}>
                {props.settingCard.editMode &&
                  (getTariff(item)?.type === "hour" ||
                    getTariff(item)?.type === "minute") && (
                    <ButtonEdit
                      onClick={() =>
                        props.setModal("AddDirection", {
                          directions: directionOrders
                            ?.map(({direction_id}) => direction_id)
                            .filter((el) => el !== item.direction_id),
                          item: props?.privateInfo?.find(
                            (el) => item.id === el.id
                          ),
                        })
                      }
                    />
                  )}
              </div>
            </div>
          );
        })}

        <div>
          {props.settingCard.editMode && (
            <Button onClick={handleAddDirection}>Добавить направление</Button>
          )}
        </div>
      </div>
    </div>
  );
};

const PersonalTariff = (props) => {
  if (props?.privateInfo?.length < 1) {
    return null
  }

  return (
    <div className={s.personalTariffList}>
      {props.privateInfo?.map((order) => (
        <PersonalTariffItem
          {...{ key: order.id, order, userRole: props.userRole }}
        />
      ))}
    </div>
  );
};

const PersonalTariffItem = memo(({ order, userRole }) => {
  const isMD = useScreenWidth(768);
  const formatBalanceValue = (value, maximumFractionDigits = 2) =>
      Number(value).toFixed(maximumFractionDigits).replace(/\.?0+$/, '')
  const tariff = useMemo(
      () =>
          order?.direction?.directionTariffs?.filter(
              (item) => item.id === order.tariff_id
          )[0],
      [order]
  );
  if (order.direction) {

    const {measurement} = billingConversion(0, {type: tariff?.type});
    const {replaceWithAnAlternative} = billingConversion(order.privateInfo.time_one_lesson, {type: tariff?.type});
    const salary = tariff.any_seminarian ? '-' : (order.privateInfo.salary_per_hour ?? 0)
    const privateBalance = Number(order.private_balance ?? 0)
    const unitPrice = Number(order.privateInfo.hour_cost ?? tariff?.first_price ?? 0)
    const lessonPrice = unitPrice
    const lessonsLeft = lessonPrice > 0 ? privateBalance / lessonPrice : 0
    const balanceText = `${formatBalanceValue(privateBalance)} руб. = ${formatBalanceValue(lessonsLeft)} занятия`

    return (
        <div className={s.personalTariffItem}>
          <h3 className={s.personalTariffTitle}>{order?.direction?.name}</h3>
          <div className={s.privateBalanceRow}>
            <span className={cn(s.privateBalanceValue, { [s.privateBalanceNegative]: privateBalance < 0 })}>
              Баланс: {balanceText}
            </span>
          </div>
          <div className={s.personalTariffItemList}>
            {isMD ? (
                <>
                  <InputNew
                      value={order.privateInfo.time_one_lesson ?? 0}
                      title={`Длительность / ${measurement}`}
                      disabled={true}
                  />
                  {userRole !== rolesEnum.seminarian && (
                      <InputNew
                          value={order.privateInfo.hour_cost ?? 0}
                          title={`Цена / ${measurement}`}
                          disabled={true}
                      />
                  )}
                  {userRole !== rolesEnum.children &&
                      <InputNew
                          value={salary}
                          title={`Педагог / ${measurement}`}
                          disabled={true}
                      />
                  }
                </>
            ) : (
                <>
                  <div className={s.personalSubelement}>
                    <span className={cn("booble")}>Длительность / {measurement}</span>
                    <span className={cn("booble booble--blue")}>
                {replaceWithAnAlternative ?? 0}
              </span>
                  </div>
                  {userRole !== rolesEnum.seminarian && (
                      <div className={s.personalSubelement}>
                        <span className={cn("booble")}>Цена / {measurement}</span>
                        <span className={cn("booble booble--blue")}>
                  {order.privateInfo.hour_cost ?? 0} {order.privateInfo.currency === 'rub'
                            ? "₽" : (order.privateInfo.currency === 'dollar' ? "$" : '€')}
                </span>
                      </div>
                  )}

                  {userRole !== rolesEnum.children &&
                      <div className={s.personalSubelement}>
                        <span className={cn("booble")}>Педагог / {measurement}</span>
                        <span className={cn("booble booble--blue")}>
                {salary}
              </span>
                      </div>
                  }
                </>
            )}
          </div>
        </div>
    );
  }
});
